import { Box, Image, MantineStyleProps, SimpleGrid } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { PropsWithChildren } from "react";
import Logo from "@/assets/login.svg";

type CleanContainerProperties = {
  w?: MantineStyleProps["w"];
};

const CleanContainer = ({ children }: PropsWithChildren<CleanContainerProperties>) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  // Mobile layout: stacked with logo on top
  if (isMobile) {
    return (
      <Box bg="white" mih="100vh">
        <Box bg="#111111" p="md">
          <Image
            src={Logo}
            alt="Acelerador de Inovação | ADI"
            style={{ height: "auto", width: "100%", maxHeight: 120, objectFit: "contain" }}
          />
        </Box>
        <Box p="lg">{children}</Box>
      </Box>
    );
  }

  // Desktop layout: side by side
  return (
    <SimpleGrid cols={2} spacing={0}>
      <Box mih="100vh" bg="#111111">
        <Image
          src={Logo}
          alt="Acelerador de Inovação | ADI"
          style={{ height: "100%", width: "100%", objectFit: "cover" }}
          p="md"
        />
      </Box>
      <Box bg="white" mih="100vh" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {children}
      </Box>
    </SimpleGrid>
  );
};

export default CleanContainer;
